if (!customElements.get('yummik-hero')) {
  customElements.define('yummik-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.slides = [...this.querySelectorAll('.yk-home-hero__slide')];
      if (this.slides.length < 2) return;
      this.index = 0;
      this.focused = this.contains(document.activeElement);
      this.editorSelected = false;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, {signal});
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); }
      }, {signal});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      this.reduced.addEventListener('change', () => this.schedule(), {signal});
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (index >= 0) { this.editorSelected = true; this.show(index); }
      }, {signal});
      document.addEventListener('shopify:block:deselect', event => {
        if (this.contains(event.target)) { this.editorSelected = false; this.schedule(); }
      }, {signal});
      this.show(0);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.abort = null;
    }
    show(next) {
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide,index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active',active);
        slide.inert = !active;
        if (active) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden','true');
      });
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      this.slides[(this.index + 1) % this.slides.length].querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
      const running = this.dataset.autoplay === 'true' && !this.reduced.matches && !this.focused && !document.hidden && !this.editorSelected && !window.Shopify?.designMode;
      this.querySelector('.yk-home-hero__track').setAttribute('aria-live','off');
      if (running) this.timer = setTimeout(() => this.show(this.index + 1),5000);
    }
  });
}
